/** @nosideeffects */
export const isDigit = /*#__INLINE__*/ (code) => {
    return code >= 48 && code <= 57;
};
/** @nosideeffects */
export const isRecord = /*#__INLINE__*/ (obj) => {
    return typeof obj === 'object' && obj !== null;
};
/** @noinline */
export const isObject = /*#__NOINLINE__*/ (obj) => {
    if (!isRecord(obj)) {
        return false;
    }
    let proto = obj;
    while (Object.getPrototypeOf(proto) !== null) {
        proto = Object.getPrototypeOf(proto);
    }
    return Object.getPrototypeOf(obj) === proto;
};
/** @nosideeffects */
export const isFunction = /*#__INLINE__*/ (fn) => {
    return typeof fn === 'function';
};
/** @nosideeffects */
export const isPromiseLike = /*#__INLINE__*/ (promise) => {
    return isRecord(promise) && isFunction(promise.then);
};
/** @nosideeffects */
export const isArray = /*#__INLINE__*/ (arr) => {
    return Array.isArray(arr);
};
/** @nosideeffects */
export const isIterable = /*#__INLINE__*/ (arr) => {
    return 'length' in arr;
};
/** @nosideeffects */
export const isNullable = /*#__INLINE__*/ (nullable) => {
    return nullable === null;
};
/** @nosideeffects */
export const isOptional = /*#__INLINE__*/ (optional) => {
    return optional == null;
};
/** @nosideeffects */
export const isResettable = /*#__INLINE__*/ (value) => {
    return value === 0 || value === '' || isOptional(value) || Number.isNaN(value);
};
/** @nosideeffects */
export const isBoolean = /*#__INLINE__*/ (bool) => {
    return bool === true || bool === false;
};
/** @noinline */
export const isEmptyObject = /*#__NOINLINE__*/ (obj) => {
    for (const _ in obj) {
        return false;
    }
    return true;
};
/** @nosideeffects */
export const isEmptyArray = /*#__INLINE__*/ (arr) => {
    return arr.length === 0;
};
/** @noinline */
export const isShallowEqual = /*#__NOINLINE__*/ (a, b) => {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    for (const i in a) {
        if (!(i in b)) {
            return false;
        }
    }
    for (const i in b) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
/** @noinline */
export const isShallowEqualArray = /*#__NOINLINE__*/ (a, b) => {
    if (a === b) {
        return true;
    }
    for (let i = a.length; i--;) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
/** @noinline */
export const isPartialEqual = /*#__NOINLINE__*/ (a, b) => {
    if (a === b) {
        return true;
    }
    if (!a || !b) {
        return false;
    }
    for (const i in a) {
        if (a[i] !== b[i]) {
            return false;
        }
    }
    return true;
};
